import { useIntl } from "react-intl";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import { useMicrofilmForm } from "./useMicrofilmForm";
import MicrofilmForm from "./components/MicrofilmForm";
import MicrofilmAbout from "./components/MicrofilmAbout";
import MicrofilmContent from "./components/MicrofilmContent";
import "./../subscribeForm/SubscribeForm.scss";

function Microfilm() {
  const intl = useIntl();
  const {
    dir,
    currentLocale,
    userInfo,
    isLoading,
    register,
    handleSubmit,
    errors,
    onSubmit,
    services,
    agencies,
    films,
    getDepartment,
    servicesTools,
  } = useMicrofilmForm();

  return (
    <ContentLoading isLoading={isLoading}>
      <div className="microfilm">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "microfilm-services" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "microfilm-title" })}
          route={"../servicestools"}
        />

        <div className="container py-5">
          <div className="row">
            <MicrofilmForm
              dir={dir}
              currentLocale={currentLocale}
              userInfo={userInfo}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              onSubmit={onSubmit}
              services={services}
              agencies={agencies}
              films={films}
            />
            <MicrofilmAbout servicesTools={servicesTools} />
          </div>
          <MicrofilmContent
            currentLocale={currentLocale}
            servicesTools={servicesTools}
            getDepartment={getDepartment}
          />
        </div>
      </div>
    </ContentLoading>
  );
}

export default Microfilm;
